import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MembershipGoals from "./smartComponents/membershipGoals";
import AttendanceGoals from "./smartComponents/attendanceGoals";
import RevenueGoals from "./smartComponents/revenueGoals";
import RetentionGoals from "./smartComponents/retentionGoals";
import DailyPulseGoals from "./smartComponents/dailyPulseGoals";
import { actionCreators } from "./redux/sagas/goals/goals";
import DonutForecastModule from "../../modules/global/donutForecast/donutForecastModule";
import { getCurrentMonthAndYear } from "../../utils/modules";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";

export function getGoalValue(item) {
  if (item.goalUsesPercent) {
    let goal = item.goalValue;
    if (!isFinite(Math.round((item.currentVal / goal) * 100))) {
      return 0;
    } else {
      return Math.round((item.currentVal / goal) * 100);
    }
  } else {
    return (item.currentVal / item.goalValue) * 100;
  }
}

export function getForecastValue(item) {
  if (item.goalUsesPercent) {
    let goal = item.goalValue;
    if (!isFinite(Math.round((item.currentValPacing / goal) * 100))) {
      return 0;
    } else {
      return Math.round((item.currentValPacing / goal) * 100);
    }
  } else {
    return (item.currentValPacing / item.goalValue) * 100;
  }
}

export class GoalsModule extends React.Component {
  componentDidMount() {
    this.props.fetchCurrentUser(this.props.currentUser);
  }

  getNumberOfActiveGoals() {
    let goalsAreActive = false;
    if (this.props.goals.attendance !== undefined) {
      this.props.goals.attendance.map((item) => {
        if (item.active) {
          goalsAreActive = true;
        }
      });
    }
    if (this.props.goals.revenue !== undefined) {
      this.props.goals.revenue.map((item) => {
        if (item.active) {
          goalsAreActive = true;
        }
      });
    }
    if (this.props.goals.memberships !== undefined) {
      this.props.goals.memberships.map((item) => {
        if (item.active) {
          goalsAreActive = true;
        }
      });
    }
    if (this.props.goals.retention !== undefined) {
      this.props.goals.retention.map((item) => {
        if (item.active) {
          goalsAreActive = true;
        }
      });
    }
    return goalsAreActive;
  }

  formatGoalsData(type) {
    let cleanedData = [];
    let dataArray;
    if (type === "top") {
      dataArray = this.props.topGoals;
    } else {
      dataArray = this.props.bottomGoals;
    }
    dataArray.map((item) => {
      cleanedData.push({
        metricTitle: item.title,
        metricLocation: item.locationName,
        hidePercentChanged: true,
        showForecast: true,
        currentValPacing: item.currentValPacing,
        forecastValue: getForecastValue(item),
        value: getGoalValue(item),
        goalCurrentVal: item.currentVal,
        goalRemainValue:
          item.prevPeriodVal * (item.goalIncrease / 100) + item.prevPeriodVal - item.currentVal,
        currencySymbol: item.currencySymbol,
        goalUsesPercent: item.goalUsesPercent,
        goalValue: item.goalValue
      });
    });
    return cleanedData;
  }
  render() {
    let cleanedDataTop = this.formatGoalsData("top");
    let cleanedDataBottom = this.formatGoalsData("bottom");
    return (
      <div className="goals-module">
        <div className="goals-month-title">
          <h2>{`Goals for ${getCurrentMonthAndYear(this.props.userParams.calendarEndDate)}`}</h2>
        </div>
        {this.props.isLoading ? (
          <LoadingAnimation />
        ) : (
          <div>
            {this.props.topGoals.length > 0 || this.props.bottomGoals.length > 0 ? (
              <div
                className="section-content-inner"
                style={{
                  paddingTop: this.getNumberOfActiveGoals() ? "40px" : "0px",
                  height: "300px",
                  position: "relative",
                  width: "1350px",
                  margin: "0 auto"
                }}
              >
                {this.props.topGoalsLoading ? (
                  <LoadingAnimation />
                ) : (
                  <>
                    <div
                      className={`goals-summary-wrapper ${
                        this.getNumberOfActiveGoals() ? "active" : ""
                      }`}
                    >
                      <div
                        className="goals-donuts"
                        style={{
                          width: "50%",
                          borderRight: "solid 1px #50555f",
                          marginRight: "16px"
                        }}
                      >
                        <h5 className="title most">Closest To Completion</h5>
                        {cleanedDataTop.map((item, key) => (
                          <DonutForecastModule
                            title={""}
                            metricTitle={item.metricTitle}
                            metricLocation={item.metricLocation}
                            hidePercentChanged
                            showForecast
                            currentValPacing={item.currentValPacing}
                            forecastValue={item.forecastValue}
                            value={item.value}
                            goalCurrentVal={item.goalCurrentVal}
                            goalUsesPercent={item.goalUsesPercent}
                            goalValue={item.goalValue}
                            goalRemainValue={item.goalRemainValue}
                            currencySymbol={item.currencySymbol}
                            currentUser={this.props.currentUser}
                            key={key}
                            width="25%"
                          />
                        ))}
                      </div>

                      {this.props.bottomGoals.length > 0 ? (
                        <div
                          className="goals-donuts"
                          style={{
                            width: "50%"
                          }}
                        >
                          <h5 className="title least">Least Likely To Succeed</h5>
                          {cleanedDataBottom.map((item, key) => (
                            <DonutForecastModule
                              title={""}
                              metricTitle={item.metricTitle}
                              metricLocation={item.metricLocation}
                              hidePercentChanged
                              showForecast
                              currentValPacing={item.currentValPacing}
                              forecastValue={item.forecastValue}
                              value={item.value}
                              goalCurrentVal={item.goalCurrentVal}
                              goalUsesPercent={item.goalUsesPercent}
                              goalValue={item.goalValue}
                              changeValue={0.03}
                              goalRemainValue={item.goalRemainValue}
                              currencySymbol={item.currencySymbol}
                              currentUser={this.props.currentUser}
                              key={key}
                              width="25%"
                            />
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
              </div>
            ) : null}
            <AttendanceGoals />
            <MembershipGoals />
            <RevenueGoals />
            <RetentionGoals />
            <DailyPulseGoals />
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.goals.isLoading,
    userParams: state.goals.currentUser,
    topGoals: state.goals.topGoals,
    bottomGoals: state.goals.bottomGoals,
    goals: state.goals.goals,
    topGoalsLoading: state.goals.topGoalsLoading
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser
  }
)(GoalsModule);

GoalsModule.propTypes = {
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  topGoals: PropTypes.array,
  bottomGoals: PropTypes.array,
  goals: PropTypes.object,
  topGoalsLoading: PropTypes.bool,
  userParams: PropTypes.object
};
